// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios";
import VueAxios from 'vue-axios';
import store from "./store/store";
import { axiosFilter } from './axios/axios'
import VueClipboard from "vue-clipboard2"; // 赋值粘贴

// npm install mavon-editor --save
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';

// npm install echarts --save
// 引入echars
import * as echarts from 'echarts/core';
// 按需引入lineChart
import {
  LineChart,
  PieChart
} from "echarts/charts";
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  MarkPointComponent, // 显示最大值最小值
  MarkLineComponent, // 显示平均值的线条
  LegendComponent,
  DataZoomComponent,
  ToolboxComponent
} from 'echarts/components';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import {
  CanvasRenderer
} from 'echarts/renderers';

// 注册必须的组件
echarts.use(
  [TitleComponent, TooltipComponent, GridComponent, LineChart, CanvasRenderer,MarkPointComponent,MarkLineComponent,LegendComponent,PieChart,DataZoomComponent,ToolboxComponent]
);
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.use(VueAxios, axios)
Vue.use(mavonEditor);
Vue.use(axiosFilter);
/**
 * 拦截是否登录
 */
router.beforeEach((to, from, next) => {
  // 设置标题, 这里用正则匹配 /admin 开头的页面都拦截。
  if(to.fullPath == '/403'){
  }else if(/^\/admin+/.test(to.fullPath)){
    if(!localStorage.getItem('wenge-skil-token')){
      next({
        path: '/login'
      });
    }
  }else if(to.fullPath == '/login'){
    document.title = '登录';
  }else if(to.fullPath.indexOf('/index/') != -1){
    // 不拦截内容。这里获取标题的name 显示到title 上
    /*if(store.getters.selUserInfo){
      let selUserInfo =  store.getters.selUserInfo;
      if(selUserInfo){
        document.title = selUserInfo.title;
      }
      // 在这里设置动态的logo
    }*/
  }else{
    let username = 'admin';
    if(localStorage.getItem('userInfo')){
      username = JSON.parse(localStorage.getItem('userInfo')).username;
    }
    next({
      path: '/index/' + username
    });
  }
  // 必须包含。否则不会跳转。
  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js